import styled from 'styled-components';

export const Toolbar = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 1020;
  display: flex;
  align-items: center;
  gap: 4px;
  min-height: 52px;
  padding: 6px 8px;
  border: 1px solid rgba(18, 14, 2, 0.08);
  border-radius: 999px;
  background: #ffffff;
  box-shadow:
    0 12px 30px rgba(18, 14, 2, 0.16),
    0 2px 8px rgba(18, 14, 2, 0.08);
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transform: ${({ $isOpen }) => ($isOpen ? 'translateY(0)' : 'translateY(calc(100% + 24px))')};
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};
  white-space: nowrap;
  transition:
    opacity 180ms cubic-bezier(0.2, 0, 0, 1),
    transform 180ms cubic-bezier(0.2, 0, 0, 1),
    visibility 0s linear ${({ $isOpen }) => ($isOpen ? '0ms' : '180ms')};

  @media (max-width: 575px) {
    right: 12px;
    bottom: 12px;
  }

  @media (prefers-reduced-motion: reduce) {
    opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
    transform: none;
    transition: none;
  }
`;

export const Action = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  color: ${({ $danger }) => ($danger ? 'var(--bs-danger)' : '#495057')};
  background: transparent;
  transition:
    color 180ms cubic-bezier(0.2, 0, 0, 1),
    background-color 180ms cubic-bezier(0.2, 0, 0, 1);

  &:hover:not(:disabled) {
    color: ${({ $danger }) => ($danger ? 'var(--bs-danger)' : '#120e02')};
    background: ${({ $danger }) => ($danger ? 'rgba(220, 53, 69, 0.1)' : '#f1f3f5')};
  }

  &:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 3px rgba(190, 22, 34, 0.22);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.38;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const SelectAllIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border: 2px solid ${({ $selected }) => ($selected ? 'var(--bs-primary)' : '#adb5bd')};
  border-radius: 50%;
  color: #ffffff;
  background: ${({ $selected }) => ($selected ? 'var(--bs-primary)' : 'rgba(73, 80, 87, 0.12)')};
  transform: ${({ $selected }) => ($selected ? 'scale(1)' : 'scale(0.94)')};
  transition:
    border-color 180ms cubic-bezier(0.2, 0, 0, 1),
    background-color 180ms cubic-bezier(0.2, 0, 0, 1),
    transform 180ms cubic-bezier(0.2, 0, 0, 1);

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const SelectedCount = styled.span`
  padding: 0 10px;
  color: #120e02;
  font-family: 'Cerebri Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
`;

export const ModalMessage = styled.p`
  max-width: 420px;
  margin: 0;
  color: #525252;
  font-family: 'Cerebri Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e9ecef;

  button {
    min-width: 104px;
  }
`;
